import { effect, inject } from '@angular/core';
import { ILocalStorageModel, StorageService } from './storage.service';

export function syncEffect<K extends keyof ILocalStorageModel>(key: K, valueGetterFn: () => ILocalStorageModel[K]) {
  const storageService = inject(StorageService);

  return effect(() => {
    storageService.set(key, valueGetterFn());
  });
}

/*export function syncEffect<T>(key: keyof T, valueGetterFn: () => T) {
  return effect(() => {
    localStorage.setItem(key.toString(), JSON.stringify(valueGetterFn()));
  })
}*/
